var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "searchPanel" },
            [
              _c("h3", { staticClass: "titulo" }, [
                _vm._v(_vm._s("Pesquisa simplificada"))
              ]),
              _c(
                "el-input",
                {
                  staticClass: "input input-with-select",
                  attrs: { placeholder: "Informe o número do processo" },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.pesquisar($event)
                    }
                  },
                  model: {
                    value: _vm.numProcesso,
                    callback: function($$v) {
                      _vm.numProcesso = $$v
                    },
                    expression: "numProcesso"
                  }
                },
                [
                  _c("el-button", {
                    staticClass: "color-default",
                    attrs: {
                      slot: "append",
                      icon: "el-icon-search",
                      id: "botao-filtro-simplificado"
                    },
                    on: { click: _vm.pesquisar },
                    slot: "append"
                  }),
                  _c("span", [_vm._v("Pesquisar")])
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "button-group" }, [
            _c(
              "div",
              { staticClass: "left-buttons" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "no-padding",
                    attrs: { type: "text", id: "botao-limpar" },
                    on: { click: _vm.limpar }
                  },
                  [_vm._v("Limpar")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm.processo
        ? _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c("card-mover-processo", {
                attrs: {
                  processo: _vm.processo,
                  opcoesAcoes: true,
                  isMaranhao: this.isMaranhao()
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.processo
        ? _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c(
                "el-row",
                { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
                [
                  _vm.processo
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-divider", {
                            attrs: { label: "Mover processo" }
                          }),
                          _c("app-label", {
                            staticStyle: { "margin-top": "20px" },
                            attrs: {
                              label:
                                "Selecione o setor que deseja mover o processo:"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticClass: "select input-with-select select",
                              attrs: {
                                placeholder: "Selecione a caixa",
                                filterable: "filterable"
                              },
                              model: {
                                value: _vm.setor,
                                callback: function($$v) {
                                  _vm.setor = $$v
                                },
                                expression: "setor"
                              }
                            },
                            _vm._l(_vm.setoresFluxo, function(setor) {
                              return _c("el-option", {
                                key: setor.acao,
                                attrs: { label: setor.nome, value: setor.acao }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.processo
                ? _c(
                    "el-row",
                    { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.processo && this.isMaranhao()
                            ? _c(
                                "div",
                                { staticClass: "botao-processo" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openModalNotificacao()
                                        }
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "center" }, [
                                        _c("i", {
                                          staticClass: "fa fa-file icon"
                                        }),
                                        _c("b", [_vm._v("  Modelo")])
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "h4",
                            {
                              staticStyle: {
                                "margin-top": "10px",
                                "margin-bottom": "30px"
                              }
                            },
                            [_vm._v("Justificativa:")]
                          ),
                          _c("app-editor-texto", {
                            ref: "editorTexto",
                            staticClass: "input",
                            on: { onTextChange: _vm.onTextChange },
                            model: {
                              value: _vm.mensagem,
                              callback: function($$v) {
                                _vm.mensagem = $$v
                              },
                              expression: "mensagem"
                            }
                          }),
                          _c("app-anexo", {
                            attrs: {
                              id: "upload-anexo-despacho",
                              files: _vm.anexos,
                              tipoExibir: "ANEXO_ANALISE"
                            },
                            on: {
                              uploadFile: _vm.uploadFile,
                              removeFile: _vm.removeFile,
                              downloadDocumentoCadastro:
                                _vm.downloadDocumentoCadastro
                            }
                          }),
                          _c("div", { staticClass: "botao-processo" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "button-mover",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.moverProcesso }
                                  },
                                  [
                                    _c("span", { staticClass: "center" }, [
                                      _c("b", [_vm._v("Mover  ")]),
                                      _c("i", {
                                        staticClass: "fas fa-chevron-right"
                                      })
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.openModal
                            ? _c("app-modal-distribuicao", {
                                attrs: {
                                  processo: _vm.processo,
                                  mensagem: _vm.mensagemFormatada,
                                  tarefa: _vm.tarefa,
                                  anexos: _vm.anexos
                                },
                                on: {
                                  closeModal: _vm.closeModal,
                                  limparDados: _vm.limpar
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.showModalNotificacao
                            ? _c("app-modal-selecionar-modelo-notificacao", {
                                attrs: {
                                  tiposModelo: _vm.tiposModelo,
                                  titulo: "Modelos de Justificativa",
                                  idProcesso: _vm.processo.id,
                                  showModal: _vm.showModalNotificacao
                                },
                                on: {
                                  closeModal: _vm.fecharModalNotificacao,
                                  setTextoJustificativa:
                                    _vm.setTextoJustificativa
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6278e441", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6278e441","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/MoverProcessos.vue
// module id = null
// module chunks = 